import {normalizeRpcTransactionData} from './getTransactionData.js';
import {getLimiter} from './../instance.js';
/**
 * Fetches a transaction by its signature.
 *
 * @param signature - The signature of the transaction.
 * @returns The transaction object.
 */
export async function fetchTransaction(signature:any,normalize:boolean | null=null) {
    const method = 'getTransaction';
    const params = [signature, { maxSupportedTransactionVersion: 0 }];
    const response = await getLimiter().fetchRpc(method,params)
    if (normalize == true){
        return normalizeRpcTransactionData(signature, response as any);
    } 
    return response
}

